import React from 'react';
import { tv } from 'tailwind-variants';

const labelStyles = tv({
  base: 'flex items-center gap-1 text-sm',
  variants: {
    fontWeight: {
      normal: 'font-normal',
      bold: 'font-bold',
      medium: 'font-medium',
    },
  },
  defaultVariants: {
    fontWeight: 'medium',
  },
});

interface LabelWithRequiredProps {
  label: string;
  fontWeight?: 'normal' | 'bold' | 'medium';
  isIcon?: true | false;
  className?: string;
}

const LabelWithRequired: React.FC<LabelWithRequiredProps> = ({ label, fontWeight, isIcon = true, className }) => {
  return (
    <div className={labelStyles({ fontWeight }) + (className ? ` ${className}` : '')}>
      <span>{label}</span>
      {isIcon && <span className='text-[var(--sematicErrorColor500)]'>*</span>}
    </div>
  );
};

export default LabelWithRequired;
